<!-- PopupLoader.vue -->
<template>
  <div v-if="PopUpLoader">
    <!-- Loader box -->
    <div class="loader-div" :class="{ popuploadercls: PopUpLoader }">
      <i class="fa-solid fa-spinner fa-spin-pulse"></i>
      <br /><br /><br />
      <b>{{ PopupLoaderText }}</b>
    </div>

    <!-- Background overlay -->
    <div class="popupbg" v-if="PopUpLoader"></div>
  </div>
</template>

<script>
export default {
  name: "PopupLoader",
  props: {
    PopupLoaderText: {
      type: String,
      default: "Loading...",
    },
    PopUpLoader: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style scoped>
.loader-div {
  position: relative;
  margin: 0 auto;
  width: 150px;
  height: 150px;
  border-radius: 15px;
  text-align: center;
  background-color: white;
  padding: 20px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
}

.fa-spinner {
  font-size: 45px;
  animation: spinner 2s linear infinite;
  margin-top: 20px;
}

@keyframes spinner {
  to {
    transform: rotate(360deg);
  }
}

.popuploadercls {
  position: fixed;
  top: 37%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 99999;
}

.popupbg {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 99998;
}
</style>
